import { render, staticRenderFns } from "./ViewTextRowTable.vue?vue&type=template&id=65f4b470&"
import script from "./ViewTextRowTable.vue?vue&type=script&lang=js&"
export * from "./ViewTextRowTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports